import React, {useMemo} from 'react';
import classnames from 'classnames/bind'

import InfoIcon from '../../images/info.svg'
import InfoColoredIcon from '../../images/info-colored.svg'

import styles from './PaymentInfo.module.scss';

const cx = classnames.bind(styles)

const PaymentInfo = ({
  className,
  data,
  detailsBtn,
  toggleDetailsModal,
}) => {
  const {
    cancellation_text: text,
    cancellation_date: date,
    cancellation_label: label,
    highlighted
  } = data;

  const showDetailsModal = () => {
    if (toggleDetailsModal) {
      toggleDetailsModal(true)
    }
  }

  const conditionsButton = useMemo(function () {
    return (
      <button
        className={cx('PaymentInfo__details-btn')}
        type="button"
        onClick={showDetailsModal}
      >
        {detailsBtn}
      </button>
    )
  }, [detailsBtn])

  return (
    <div className={cx('PaymentInfo', className, {'PaymentInfo--highlighted': highlighted})}>
      <div className={cx('PaymentInfo__title-wrap')}>
        <span className={cx('PaymentInfo__icon', {highlighted})} />
        <p className={cx('PaymentInfo__text')}>
          {label}
          <span>{date}</span>
        </p>
        { !text && conditionsButton }
      </div>
      {text && (
        <>
          <p className={cx('PaymentInfo__description')}>{text}</p>
          {conditionsButton}
        </>
      )}
    </div>
  )
}

export default PaymentInfo
